var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "viq-confidence",
      class: "viq-confidence--" + _vm.normalizedLevel,
    },
    [
      _c("span", { staticClass: "viq-confidence__dot" }),
      _vm._v("\n  " + _vm._s(_vm.label) + " confidence\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }